import "../utils/setWebpackPublicPath";
import { MainWebsiteEvents, SubscriptionEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";
import { setStorefrontFromLocation, setOwnerFromLocation } from "@glamcorner/core-cf-lib/lib/client";
import "./Analytics";
import initialiseAnalytics from "./Analytics2";
import Bus from "./Bus";
import GcSession from "./GcSession";
import { LazyProductImageLoader } from "./LazyProductImageLoader";
import { EMBED_APP_EVENTS } from "./constants";
import { UserSession } from "./UserSession";
import ProfileService from "../common/services/ProfileService";

const bus = new Bus();
const gcSession = new GcSession(bus); // kick off xhr request as early as possible

window.dataLayer = window.dataLayer || [];
initialiseAnalytics(window.dataLayer, bus);

const BusEvents = {
  EMBED_APP_EVENTS,
};

const ipcBusEvents = {
  MainWebsiteEvents,
  SubscriptionEvents,
};

const userSession = new UserSession();
const profileService = new ProfileService();

function init() {
  const timer = setInterval(() => {
    // im surprised we have to do this, but it seems we were running before document.body is defined.
    if (window.document.body) {
      clearInterval(timer);
      setStorefrontFromLocation();
      setOwnerFromLocation();
    }
  }, 50);
}

// it's not nice that loading a module causes it to / has side-effects.
// so we might remove this call at some point and only export it.
init();

export {
  init,
  bus,
  gcSession,
  LazyProductImageLoader,
  BusEvents,
  ipcBusEvents,
  userSession,
  setStorefrontFromLocation,
  profileService,
};
